import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'bootstrap/scss/bootstrap.scss'
import '@/scss/bootstrap.scss'
import '@/scss/app.scss'

import 'bootstrap'

createApp(App)
  .use(store)
  .use(router)
  .mount('#app')
